export function parseWarningToMarkdown(blocks) {
  const formatted = blocks.message
      .replace(/<b>(.*?)<\/b>/g, '*$1*')
      .replace(/<i>(.*?)<\/i>/g, '_$1_')
      .replace(/<u[^>]*>(.*?)<\/u>/g, '+$1+')
      .replace(/<code.*?>(.*?)<\/code>/g, '{{$1}}')
      .replace(/<mark.*?>(.*?)<\/mark>/g, '{color:#0747a6}$1{color}')
      .replace(/<a href="(.*?)">(.*?)<\/a>/g, '[$2|$1|smart-link]')
      .replace(/<br\s*\/?>/g, '\n')
      .replace(/&nbsp;/g, ' ');

  return `{panel:bgColor=#deebff}${formatted}{panel}\n`;
}
